<template>
  <v-ons-page>

    <div class="header" style="text-align: center;">
      <img src="../../assets/lasmeru-logo-bold.png" width="250" height="100" style="margin-top: 50px; margin-bottom: 30px;">
      <!-- <img src="../../assets/miley-commu-logo-70x40px-b.png" style="margin-left; 20px;"> -->
    </div>

    <div>
      <!-- <p>Google、Facebookアカウントを持っている方は、各サービスバナーをタップしてください。</p> -->
      <!-- <p>Googleアカウントを持っている方は、Googleバナーをタップしてください。</p> -->
      <p>
        ラスメルでは、メールリンク認証方式を採用しています。<br>
        メールアドレスのみで登録できて、パスワードは不要です。<br>
        メールアドレスを入力して頂くと、確認用のメールが送信されます。<br>
        メール内に記載のリンクを押してください。<br>
        同じデバイス上でメールリンクが押されなかった場合には<br>
        確認のために再度メールアドレスの入力が必要となります。
      </p>
    </div>

    <!-- <div>
      <v-ons-button @click="authRedirectGoogle()">直接GOOGLE</v-ons-button>
    </div> -->

    <div id="firebaseui-auth-container"></div>
    <div id="loader">Loading...</div>

  </v-ons-page>
</template>

<script>
import firebase from 'firebase'
import * as firebaseui from 'firebaseui'
import 'firebaseui/dist/firebaseui.css'

// import * as firebaseui from '../firebaseui_js/firebaseui__ja'
// import firebaseui from '../firebaseui/npm__ja'
// import '../firebaseui/firebaseui.css'
// import '../firebaseui_js/firebaseui.css'
import common from '../../util/common'

export default {
  name: 'SignUp',
  mixins: [common],
  data () {
    return {
    }
  },

  created () {
  },

  mounted () {
    // window.handleOpenURL = function (url) {
    //   setTimeout(function () {
    //     console.log('handleOpenURL: ', url)
    //     alert('received url: ' + url)
    //   }, 0)
    // }

    this.initAuth()
  },

  computed: {
  },

  watch: {
  },

  methods: {
    authRedirectGoogle () {
      var self = this
      var provider = new firebase.auth.GoogleAuthProvider()

      firebase.auth().signInWithRedirect(provider).then(function () {
        return firebase.auth().getRedirectResult()
      }).then(function (result) {
        // This gives you a Google Access Token.
        // You can use it to access the Google API.
        var token = result.credential.accessToken
        console.log('token: ', token)
        // The signed-in user info.
        var user = result.user
        self.$ons.notification.alert('成功です: ' + user)
      }).catch(function (error) {
        // Handle Errors here.
        var errorCode = error.code
        var errorMessage = error.message
        self.$ons.notification.alert('エラー: ' + errorCode + ' : ' + errorMessage)
      })
    },
    initAuth () {
      // FirebaseUIインスタンス初期化
      firebase.auth().languageCode = 'ja'
      var ui = new firebaseui.auth.AuthUI(firebase.auth())
      console.log('ui', ui)
      // FirebaseUIの各種設定
      var uiConfig = {
        callbacks: {
          // signInSuccess: function (currentUser, credential, redirectUrl) {
          //   // サインイン成功時のコールバック関数
          //   // 戻り値で自動的にリダイレクトするかどうかを指定
          //   return true
          // },
          signInSuccessWithAuthResult: function (authResult, redirectUrl) {
            console.log('signInSuccess: ', authResult, redirectUrl)
            return true
          },
          signInFailure: function (error) {
            // Some unrecoverable error occurred during sign-in.
            // Return a promise when error handling is completed and FirebaseUI
            // will reset, clearing any UI. This commonly occurs for error code
            // 'firebaseui/anonymous-upgrade-merge-conflict' when merge conflict
            // occurs. Check below for more details on this.
            console.log('signInFailure error', error)
            return (error)
          },
          uiShown: function () {
            // FirebaseUIウィジェット描画完了時のコールバック関数
            // 読込中で表示しているローダー要素を消す
            document.getElementById('loader').style.display = 'none'
          }
        },
        // リダイレクトではなく、ポップアップでサインインフローを表示
        // signInFlow: 'popup',
        // Cordova ではポップアップが使えないのでリダイレクト
        signInFlow: 'redirect',
        signInSuccessUrl: '/',
        signInOptions: [
          // firebase.auth.GoogleAuthProvider.PROVIDER_ID,
          // firebase.auth.FacebookAuthProvider.PROVIDER_ID,
          // firebase.auth.TwitterAuthProvider.PROVIDER_ID,
          {
            // サポートするプロバイダ(メールアドレス)を指定
            provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
            requireDisplayName: false,
            signInMethod: firebase.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD,
            // Allow the user the ability to complete sign-in cross device,
            // including the mobile apps specified in the ActionCodeSettings
            // object below.
            forceSameDevice: false
          }
        ]
        // Terms of service url.(サービス利用規約ページの)
        // tosUrl: '<your-tos-url>',
        // Privacy policy url.
        // privacyPolicyUrl: '<your-privacy-policy-url>'
      }

      // FirebaseUI描画開始
      // console.log('ui.isPendingRedirect()', ui.isPendingRedirect())
      // if (ui.isPendingRedirect()) {
      ui.start('#firebaseui-auth-container', uiConfig)
      // }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* @import "../../../src/assets/css/miley.css"; */
/* @import "../../../node_modules/firebaseui/dist/firebaseui.css"; */
p {
    text-align: left;
    margin-left: 10px;
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/AccountChildren/SignUp.vue